import { Injectable, NgZone } from '@angular/core';
import { Router } from '@angular/router';
import { Observable, Subscriber } from 'rxjs';
import { ApigeeService } from '../apigee/apigee.service'
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class AuthGuard {

  constructor(private router: Router,
    private zone: NgZone,
    private apigeeService: ApigeeService) { }

  canActivate()
    : Observable<boolean> | Promise<boolean> | boolean {

    return new Observable<boolean>(observer => {
      this.checkApiToken().subscribe(response => {

        if (!response) {
          this.responseCanActive(observer, false);
        } else {
          this.apigeeService.getUserInfoApi().subscribe(() => {
            this.responseCanActive(observer, true);
          });
        }
      }, error => {
        observer.error(error);
      });
    });
  }

  /**
   * Realiza el proceso de respuesta del CanActive
   * @param value Valor de la respuesta
   */
  responseCanActive(observer: Subscriber<boolean>, value: boolean) {
    observer.next(value);
    observer.complete();
  }

  /**
   * Realiza una comprobación del token JWT para asegurar que estamos logados
   * @returns Posible entrada a la pagina
   */
  checkApiToken(): Observable<boolean> {
    return this.apigeeService.ensureValidToken().pipe(
      map(valid => {
        if (!valid) {
          this.zone.run(() => this.router.navigate(['login']));
        }
        return valid;
      })
    );
  }
}
